// extracted by mini-css-extract-plugin
export var contentBody = "_6l-9";
export var headerImage = "_6l-2";
export var imageButton = "_6l-7";
export var imageButtonIcon = "_6l-8";
export var imageHeader = "_6l-4";
export var imageHeaderText = "_6l-5";
export var imageOverlay = "_6l-3";
export var imageTitle = "_6l-6";
export var imageWrapper = "_6l-1";
export var taskList = "_6l-a";
export var widget = "_6l-0";